<!-- eslint-disable no-unused-vars -->
<template>
  <div>
    <b-card
      v-show="is_project_expense == null"
      title="Tipo de despesa"
      class="text-left"
    >
      <b-row class="my-1 m-2 text-center justify-content-center">
        <b-col cols="12" md="6">
          <b-button
            class="w-100 mb-2"
            variant="primary"
            @click="(is_project_expense = true), setType()"
            >Projeto</b-button
          >
        </b-col>
        <b-col cols="12" md="6">
          <b-button
            variant="warning"
            class="w-100"
            @click="(is_project_expense = false), setType()"
            >Escritório</b-button
          >
        </b-col>
      </b-row>
    </b-card>

    <b-card v-show="is_project_expense != null" title="" class="text-left">
      <!-- <b-row
          class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center"
        >
          <b-col cols="12" xs="12" sm="12" md="6" lg="6">
            <b-form-checkbox
              v-model="is_project_expense"
              name="check-button"
              @change="setType"
              switch
            >
              Despesa (custo) de projeto
            </b-form-checkbox>
          </b-col>
        </b-row> -->

      <!-- Projeto -->
      <b-form @submit.prevent="saveItem">
        <b-row class="my-1 m-2 pl-2 pr-2 text-left justify-content-center">
          <b-col v-show="is_project_expense" cols="12" md="8">
            <b-form-group>
              <label
                for="projectSelect"
                class="text-center font-weight-bold text-primary"
              >
                Projeto :
              </label>

              <div
                @click="handleShowArquived()"
                :style="{ color: 'blue', padding: '5px 0', cursor: 'pointer' }"
              >
                {{
                  showArquivded ? 'Ocultar arquivados' : 'Mostrar arquivados'
                }}
              </div>

              <v-select
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                placeholder="Selecione um projeto"
                v-model="item.project_id"
                :options="projects"
                label="name"
                :searchable="true"
                :reduce="(project) => project.id"
              />
              <p v-if="$v.item.project_id.$error" style="color: red">
                *O projeto é necessário.
              </p>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row
          class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center"
        >
          <b-col cols="12" md="8">
            <b-form-group class="mb-2">
              <label for="category" class="font-weight-bold text-primary">{{
                is_project_expense
                  ? 'Categoria do custo de PROJETO'
                  : 'Categoria do custo de ESCRITORIO'
              }}</label>

              <v-select
                ref="vselect"
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                placeholder="Selecione uma categoria"
                v-model="item.expense_category_id"
                :options="categories"
                label="expense_category_name"
                :searchable="true"
                :reduce="(category) => category.id"
              />
              <p v-if="$v.item.expense_category_id.$error" style="color: red">
                *Uma categoria é necessária.
              </p>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row
          class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center"
        >
          <b-col cols="12" md="8">
            <label for="category" class="font-weight-bold text-primary"
              >Fornecedor :</label
            >

            <v-select
              ref="vselect_supplier"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              placeholder="Selecione uma categoria"
              v-model="item.supplier_id"
              :options="supplier"
              label="supplier_name"
              :searchable="true"
              :reduce="(supplier) => supplier.id"
            />
            <p v-if="$v.item.supplier_id.$error" style="color: red">
              *Um fornecedor é necessário.
            </p>
          </b-col>
        </b-row>

        <!-- Valor -->
        <b-row
          class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center"
        >
          <b-col cols="12" md="8">
            <b-form-group>
              <label
                for="value"
                class="text-center font-weight-bold text-primary"
                >Valor :</label
              >

              <b-input-group>
                <BFormInput
                  id="value"
                  type="text"
                  v-model="item.value"
                  v-money="moneyMask"
                ></BFormInput
                ><br />
              </b-input-group>
              <div
                v-if="$v.item.value.$error"
                style="color: red"
                class="d-block"
              >
                *Valor precisa ser maior que zero.
              </div>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Data Refrencia -->

        <b-row
          class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center"
        >
          <b-col cols="12" md="8">
            <b-form-group>
              <label for="date" class="font-weight-bold text-primary"
                >Data de Referência :</label
              >
              <BFormInput
                id="date"
                type="date"
                v-model="item.reference_date"
              ></BFormInput>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Data Transação -->

        <b-row
          class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center"
        >
          <b-col cols="12" md="8">
            <b-form-group>
              <label for="date" class="font-weight-bold text-primary"
                >Data de Transação :</label
              >
              <BFormInput
                id="date"
                type="date"
                v-model="item.transaction_date"
              ></BFormInput>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Status -->
        <b-row
          class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center"
        >
          <b-col cols="12" md="8">
            <b-form-group>
              <label for="status" class="font-weight-bold text-primary"
                >Status :</label
              >
              <b-form-select
                id="status"
                v-model="item.status"
                :options="statusOptions"
                placeholder="Selecione o status"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <!-- Tipo -->
        <b-row
          class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center"
        >
          <b-col cols="12" md="8">
            <b-form-group>
              <label class="font-weight-bold text-primary"
                >Condição de Pagamento:</label
              >
              <b-form-select
                v-model="item.type"
                :options="typesOptions"
                placeholder="Selecione o status"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Descrição -->
        <b-row
          class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center"
        >
          <b-col cols="12" md="8">
            <b-form-group>
              <label for="description" class="font-weight-bold text-primary"
                >Descrição :</label
              >
              <BFormTextarea
                id="description"
                type="textarea"
                v-model="item.description"
              ></BFormTextarea>
            </b-form-group>
          </b-col>
        </b-row>

        <!-- Se Parcelado -->
        <div
          v-if="
            item.type == 'Parcelado' ||
            (item.type == 'Recorrência' && item.value)
          "
        >
          <b-row
            class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center"
          >
            <b-col cols="12" md="8">
              <b-form-group>
                <b-input-group
                  :prepend="
                    item.type == 'Parcelado' ? 'Parcelas' : 'Recorrências'
                  "
                >
                  <BFormInput
                    id="installmentsInput"
                    type="number"
                    v-model="installmentsInput"
                  ></BFormInput>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>

          <!-- Parcelas -->
          <div v-if="item.value && installmentsInput > 0">
            <div v-for="i in parseInt(installmentsInput)" :key="i">
              <b-row
                class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center"
              >
                <b-col cols="12" md="8">
                  <b-form-group>
                    <b-input-group prepend="R$">
                      <BFormInput
                        :id="`installment-value`"
                        type="text"
                        :ref="`installments-value-${i}`"
                        :value="
                          numberToMonetary(
                            monetaryToNumber(item.value) /
                              parseInt(installmentsInput),
                          )
                        "
                        v-money="moneyMask"
                      ></BFormInput>
                    </b-input-group>
                  </b-form-group>
                </b-col>

                <b-col cols="12" md="8">
                  <b-form-group prepend="">
                    <BFormInput
                      :id="`installment-date`"
                      :ref="`installments-date-${i}`"
                      type="date"
                      :value="installmentIncrease(i)"
                    ></BFormInput>
                  </b-form-group>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
        <!-- Se Repetir -->

        <b-row
          class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center"
        >
          <b-col cols="12" md="8">
            <b-alert show variant="primary">
              <p class="text-center">
                <br />
                Inserindo custo de
                {{ is_project_expense ? 'PROJETO' : 'ESCRITÓRIO' }}
              </p>
              <hr />
            </b-alert>
          </b-col>
        </b-row>

        <b-row
          v-if="item.type == 'Recorrência' || item.type == 'Parcelado'"
          class="my-1 m-2 pl-2 pr-2 text-left d-flex justify-content-center"
        >
          <b-col cols="12" md="8">
            <b-alert show variant="success" class="p-1">
              <p class="text-center">
                Transações
                {{
                  item.type == 'Recorrência'
                    ? 'de RECORRÊNCIA são despesas ordinárias para manutenção do escritório. (Aluguel, energia, água, internet)'
                    : 'de PARCELAMENTO são aquelas operações que necessitam de prazo para serem realizadas.'
                }}
              </p>
            </b-alert>
          </b-col>
        </b-row>

        <!-- Botoes -->
        <div class="justify-center">
          <BButton variant="outline" @click="$router.go(-1)">Voltar</BButton>
          <BButton type="submit" variant="primary">Salvar</BButton>
        </div>
      </b-form>
    </b-card>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core';
import { requiredIf, required } from '@vuelidate/validators';
import {
  BCard,
  BForm,
  BButton,
  BFormGroup,
  BFormInput,
  BFormTextarea,
  BCol,
  BRow,
  BFormSelect,
  BInputGroup,
  BAlert,
} from 'bootstrap-vue';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import { VBTooltip } from 'bootstrap-vue';
import moment from 'moment';

export default {
  directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    BCard,
    BForm,
    BFormInput,
    BCol,
    BRow,
    BFormGroup,
    BFormTextarea,
    BFormSelect,
    BButton,
    BInputGroup,
    BAlert,
  },
  data: () => ({
    is_project_expense: null,
    supplier_id: '',
    hasMore: true,
    isLoading: false,
    page: 1,
    perPage: 1000,
    categories: [],
    item: {
      project_id: null,
      type: 'À vista (uma vez)',
      status: 'realizado',
      value: 0,
      expense_category_id: null,
      repeat: 0,
      transaction_date: moment().format('YYYY-MM-DD'),
      reference_date: moment().format('YYYY-MM-DD'),
    },
    moneyMask: {
      prefix: '',
      suffix: '',
      thousands: '.',
      decimal: ',',
      precision: 2,
      masked: false,
    },

    supplier: [],
    installments: [],
    projects: [],
    created_by: '',
    installmentsInput: 2,
    statusOptions: ['previsto', 'realizado'],
    typesOptions: ['À vista (uma vez)', 'Parcelado', 'Recorrência'],
    showArquivded: false,
    instalment_date_increase: moment().format('YYYY-MM-DD'),
  }),
  validations() {
    return {
      item: {
        project_id: {
          required: requiredIf(function () {
            return this.is_project_expense == true;
          }),
        },
        expense_category_id: {
          required,
        },
        supplier_id: {
          required,
        },
        value: {
          required,
          notZero: (value) => value !== '0,00',
        },
      },
    };
  },

  setup() {
    return { $v: useVuelidate() };
  },
  created() {
    this.getProjects();
    //this.getCategories();
    this.getSupplier();
    this.getMemberId();
  },

  computed: {
    currentUser() {
      return this.$store.getters.user.accesses.find(
        (a) => a.workspace_id == this.$store.getters.currentWorkspace.id,
      );
    },
  },

  methods: {
    async getMemberId() {
      await this.$store
        .dispatch('getUserMember', {
          id: this.currentUser.user_id,
          workspace_id: this.$store.getters.currentWorkspace.id,
        })
        .then((resp) => {
          console.log('membro ', resp);
          this.created_by = resp[0].member_id;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    setType() {
      this.typesOptions = [];
      if (this.is_project_expense == true) {
        this.typesOptions.push('À vista (uma vez)', 'Parcelado');
      } else {
        this.typesOptions.push('À vista (uma vez)', 'Parcelado', 'Recorrência');
      }
      this.getCategories();
    },
    async getCategories() {
      if (this.isLoading || !this.hasMore) return;

      this.isLoading = true;

      const params = {
        inactive: false,
        workspace_id: this.$store.getters.currentWorkspace.id,
        cost_category: this.is_project_expense ? 'project' : null,
        page: this.page,
        perPage: this.perPage,
      };

      try {
        const resp = await this.$store.dispatch('getAllCostsCategory', params);

        if (resp && resp.data) {
          this.categories = [...this.categories, ...resp.data];
          const pagination = resp.pagination;

          if (pagination.page >= pagination.lastPage) {
            this.hasMore = false;
          } else {
            this.page++;
          }
        }
      } catch (err) {
        console.error(err);
      }
      this.isLoading = false;
    },
    async getSupplier() {
      await this.$store
        .dispatch('getAllSuppliers', {
          workspace_id: this.$store.getters.currentWorkspace.id,
        })
        .then((resp) => {
          if (resp) {
            this.supplier = resp;
          }
        });
    },
    async getProjects() {
      let body = {
        id: this.$route.params.id,
        workspace_id: this.$store.getters.currentWorkspace.id,
        page: 1,
        perPage: 1000,
      };
      this.$store
        .dispatch('_getProjects', this.formatQueryParams(body))
        .then((resp) => {
          resp.data.map((e) => {
            if (this.showArquivded) {
              this.projects.push({
                id: e.id,
                name: `${e.project_code} - ${e.project_name} ${
                  e.is_archived ? '(Arquivado)' : ''
                }`,
              });
            } else {
              if (e.is_archived) {
                return null;
              } else {
                this.projects.push({
                  id: e.id,
                  name: `${e.project_code} - ${e.project_name} ${
                    e.is_archived ? '(Arquivado)' : ''
                  }`,
                });
              }
            }
          });
        })
        .catch((err) => {
          console.log(err);
        });
    },

    async saveItem() {
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      //console.log('id do usuario', this.currentUser.id)
      if (
        this.item.type === 'Parcelado' ||
        (this.item.type === 'Recorrência' && this.installmentsInput > 0)
      ) {
        for (let i = 1; i <= parseInt(this.installmentsInput); i++) {
          const valueInstallments = this.monetaryOnlyCommas(
            this.$refs[`installments-value-${i}`][0].value,
          );

          const dateInstallments =
            this.$refs[`installments-date-${i}`][0].$refs.input.value;

          this.installments.push({
            value: valueInstallments,
            transaction_date: dateInstallments,
          });
        }
      }

      this.$store
        .dispatch('saveExpense', {
          ...this.item,
          description: this.item.description
            ? this.item.description
            : 'Sem descrição',
          value: this.monetaryToNumber(this.item.value),
          installments: this.installments,
          repeat: this.item.type === 'Recorrência' ? 1 : 0,
          workspace_id: this.$store.getters.currentWorkspace.id,
          is_project_expense: this.is_project_expense,
          created_by: this.created_by,
        })
        .then(() => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Despesa registrada com sucesso.',
              icon: 'SuccessIcon',
              variant: 'success',
            },
          });
          this.$router.go(-1);
        })
        .catch((error) => {
          console.log(error);
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Erro ao lançar despesa.',
              message: error,
              icon: 'XIcon',
              variant: 'danger',
            },
          });
        });
    },

    installmentIncrease(i) {
      let installmentDate = moment(this.item.transaction_date);
      installmentDate.add(i - 1, 'months');

      return installmentDate.format('YYYY-MM-DD');
    },

    async createInstallmentsLength() {
      if (this.installments.length < this.installmentsInput) {
        for (
          let i = this.installments.length;
          i < this.installmentsInput;
          i++
        ) {
          this.installments.push({ value: 0 });
        }
      } else if (
        this.installments.length > this.installmentsInput &&
        this.installmentsInput !== 0
      ) {
        for (
          let i = this.installments.length - 1;
          i >= this.installmentsInput;
          i--
        ) {
          console.log('minus');
          this.installments.pop();
        }
      }

      console.log(this.installments);
    },

    handleShowArquived() {
      this.showArquivded = !this.showArquivded;
      this.projects = [];
      this.getProjects();
    },
  },
};
</script>
<style>
.justify-center {
  display: flex;
  justify-content: center;
}
td::before {
  float: none !important;
}
</style>
